import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from 'react-router-dom';

const gridColumns = '2fr 1fr 1fr';

const sectionHeaderStyle = {
  display: 'grid',
  gridTemplateColumns: gridColumns,
  fontSize: '13px',
  color: '#666',
  paddingBottom: '6px',
  marginTop: '20px',
};

const rowStyle = {
  display: 'grid',
  gridTemplateColumns: gridColumns,
  alignItems: 'center',
  padding: '4px',
  fontSize: '14px',
  borderBottom: '1px solid black',
};

export const Section = ({
  nameLabel,
  countLabel = 'Number of Refresh Results',
  rows,
  onRowClick,
}) => {
  if (!rows.length) return null;
  return (
    <>
      <div style={{ ...sectionHeaderStyle }}>
        <div style={{ textAlign: 'left' }}>{nameLabel}</div>
        <div style={{ textAlign: 'center' }}>{countLabel}</div>
        <div style={{ textAlign: 'center' }}>Actions</div>
      </div>
      {rows.map((row) => (
        <div key={row.vertical_id} style={rowStyle}>
          <div style={{ textAlign: 'left' }}>{row.name}</div>
          <div style={{ textAlign: 'center' }}>{row.count}</div>
          <div style={{ textAlign: 'center' }}>
            <IconButton size="small" onClick={() => onRowClick(row.vertical_id)}>
              <ChevronRightIcon style={{ color: '#1976d2' }} />
            </IconButton>
          </div>
        </div>
      ))}
    </>
  );
};

const NewRefreshResultsModal = ({ open, onClose, rows }) => {
  const navigate = useNavigate();

  const draft = rows.filter((r) => r.status === 'Created' && (r.invited_count ?? 0) === 0);
  const mine = rows.filter((r) => r.status === 'Created' && (r.invited_count ?? 0) > 0);
  const joined = rows.filter((r) => r.status === 'Joined' && r.permission === 'AdvancedEditor');

  const handleRowClick = (verticalId) => {
    onClose();
    navigate(`/vertical/${verticalId}/home`);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth style={{ padding: 12 }}>
      <DialogTitle
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 700,
        }}
      >
        New Discovery Refresh Results
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Section nameLabel="Private Vertical Name" rows={draft} onRowClick={handleRowClick} />
        <Section nameLabel="My Vertical Name" rows={mine} onRowClick={handleRowClick} />
        <Section nameLabel="Joined Vertical Name" rows={joined} onRowClick={handleRowClick} />
      </DialogContent>
    </Dialog>
  );
};

export default NewRefreshResultsModal;
